// --------------------------------------------------------
//MEDICAL RECORD - MedicalRecord
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------

import React from "react";
import { H3 } from "../../../components/UI/generalLayout/Layout.styled";
import { Spacer } from "../../../components/UI/spacer/spacer";
import { Container, InputFullGray } from "./InputInformation.styled";
import Colors from "../../../constants/Colors";
import useResponsiveInfo from "../../../hooks/useResponsiveInfo";

// --------------------------------------------------------
// MEDICAL RECORD INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */

interface IInputInformation {
  descricao?: string;
  name?: string;
  value?: string;
  placeholder?: string;
}

function InputInformation({
  descricao,
  name,
  value,
  placeholder,
}: IInputInformation): JSX.Element {
  // --------------------------------------------------------
  // MEDICAL RECORD PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo()

  return (
    <Container>
      <H3>{descricao}</H3>
      <Spacer top={20} />
      <InputFullGray
        style={{ backgroundColor: Colors.GRAY200, cursor: "default" }}
        name={name}
        value={value}
        type={"text"}
        placeholder={placeholder}
        disabled={true}
        isMobile={isMobile}
        max={0}
        width={10}
      />
    </Container>
  );
}

export default InputInformation;
